import {match} from 'ts-pattern';

import {createElement, ReactNode} from 'react';

import type {OAuthProviders, SmtpEmailProviderCode} from '@dms/api/core';

import customSmtpLogo from '../assets/custom-smtp-logo.svg';
import gmailLogo from '../assets/gmail-logo.svg';
import microsoftLogo from '../assets/microsoft-logo.svg';
import outlookLogo from '../assets/outlook-logo.svg';
import seznamLogo from '../assets/seznam-logo.svg';

export const getSmtpProviderLogo = (code: SmtpEmailProviderCode | OAuthProviders): ReactNode => {
  const LogoComponent = match(code)
    .with('gmail-smtp', () => gmailLogo)
    .with('outlook-smtp', () => outlookLogo)
    .with('seznam-smtp', () => seznamLogo)
    .with('custom-smtp', () => customSmtpLogo)
    .with('microsoft-oauth', 'microsoft', () => microsoftLogo)
    .otherwise(() => customSmtpLogo);

  return createElement(LogoComponent);
};
